/* Bluvana Silk — header menus, mobile drawer, hero video. */
(function () {
  var mq = window.matchMedia('(max-width: 1000px)');

  /* Header over the hero: see-through at the top, solid once scrolled.
     Desktop scrolls .page-wrapper, phones scroll the document. */
  function headerSolid() {
    var group = document.getElementById('header-group');
    if (!group || !document.body.classList.contains('silk-home-template')) return;
    var ticking = false;

    function scroller() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 2 && /auto|scroll/.test(window.getComputedStyle(pw).overflowY)) return pw;
      return document.scrollingElement || document.documentElement;
    }

    function sync() {
      ticking = false;
      group.classList.toggle('is-solid', scroller().scrollTop > 8);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }

    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    sync();
  }

  function heroVideo() {
    var v = document.querySelector('[data-sk-hero-video]');
    if (!v) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.removeAttribute('autoplay');
      v.pause();
    }
  }

  function menus() {
    var items = [].slice.call(document.querySelectorAll('[data-sk-drop]'));
    var scrim = document.querySelector('[data-sk-scrim]');
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var t = it.querySelector('[data-sk-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (scrim && !except) scrim.classList.remove('is-on');
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-sk-trigger]');
      if (!trigger) return;

      function open(state) {
        item.classList.toggle('is-open', state);
        trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
        if (scrim) scrim.classList.toggle('is-on', state);
        if (state) closeAll(item);
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        open(!item.classList.contains('is-open'));
      });
      item.addEventListener('mouseenter', function () {
        if (!mq.matches) open(true);
      });
      item.addEventListener('mouseleave', function () {
        if (!mq.matches) open(false);
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) open(false);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sk-drop]')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    if (scrim) scrim.addEventListener('click', function () { closeAll(); });
  }

  function drawer() {
    var el = document.querySelector('[data-sk-drawer]');
    var open = document.querySelector('[data-sk-open]');
    var close = document.querySelector('[data-sk-close]');
    if (!el || !open) return;

    function set(state) {
      el.classList.toggle('is-open', state);
      el.setAttribute('aria-hidden', state ? 'false' : 'true');
      open.setAttribute('aria-expanded', state ? 'true' : 'false');
      document.documentElement.style.overflow = state ? 'hidden' : '';
    }

    open.addEventListener('click', function () { set(true); });
    if (close) close.addEventListener('click', function () { set(false); });
    el.addEventListener('click', function (e) {
      if (e.target.closest('a')) set(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') set(false);
    });

    [].slice.call(el.querySelectorAll('[data-sk-acc]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var on = btn.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  }


  /* Lookbook strip: pointer drag, click a cell to bring it forward, arrows.
     Deliberately no visible scrollbar; the native chrome cheapens the brand. */
  function strip() {
    var vp = document.querySelector('[data-sk-strip]');
    if (!vp) return;
    var track = vp.querySelector('[data-sk-strip-track]');
    var prev = vp.querySelector('[data-sk-strip-prev]');
    var next = vp.querySelector('[data-sk-strip-next]');
    if (!track) return;

    var down = false, moved = false, startX = 0, startScroll = 0;

    function step() {
      var cell = track.firstElementChild;
      if (!cell) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return cell.getBoundingClientRect().width + gap;
    }

    var nowEl = vp.parentNode.querySelector('[data-sk-strip-now]');
    var countEl = vp.parentNode.querySelector('[data-sk-strip-count]');
    var photos = track.querySelectorAll('.sk-line__cell:not(.sk-line__cell--end)').length;

    if (countEl && photos) {
      countEl.lastChild.nodeValue = ' / ' + String(photos).padStart(2, '0');
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (nowEl && photos) {
        var i = Math.min(photos, Math.round(track.scrollLeft / step()) + 1);
        nowEl.textContent = String(i).padStart(2, '0');
      }
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) track.scrollLeft = startScroll - dx;
    });

    function release(e) {
      if (!down) return;
      down = false;
      if (track.hasPointerCapture && e.pointerId != null) {
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) {
        track.classList.remove('is-dragging');
        /* settle on the nearest cell so a flick still lands cleanly */
        var s = step();
        track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: 'smooth' });
      }
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);

    /* a click that was not a drag brings that photo to the front */
    [].slice.call(track.children).forEach(function (cell) {
      cell.addEventListener('click', function () {
        if (moved) return;
        track.scrollTo({ left: cell.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }


  /* Auto rotating rails. Items are rendered twice, so once the scroll passes
     the halfway mark we jump back by exactly half the track width. The content
     is identical there, so the seam is invisible and the loop never ends. */
  /* Product rails: up to twelve cards, first to last, no loop. Every move is
     a smooth scroll to a whole-card target; arrows switch off at the ends;
     mouse drag and native touch scrolling snap to the nearest card. The
     auto-advance walks to the last card and stops. */
  function rails() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var INTERVAL = 6000;

    [].slice.call(document.querySelectorAll('[data-sk-rail]')).forEach(function (rail) {
      if (rail.hasAttribute('data-sk-rail-on')) return;
      var track = rail.querySelector('[data-sk-rail-track]');
      var prev = rail.querySelector('[data-sk-rail-prev]');
      var next = rail.querySelector('[data-sk-rail-next]');
      /* too thin to scroll — leave the rail unmarked so a later content
         swap (real recommendations arriving) can still initialise it */
      if (!track || track.children.length < 2) return;
      rail.setAttribute('data-sk-rail-on', '');

      var timer = null, paused = false, settle = null;
      var down = false, moved = false, startX = 0, startScroll = 0;

      function step() {
        var cell = track.firstElementChild;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
        return cell.getBoundingClientRect().width + gap;
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function clamp(x) {
        return Math.min(maxScroll(), Math.max(0, x));
      }

      function snap(x) {
        var s = step();
        return clamp(Math.round(x / s) * s);
      }

      /* arrows reflect where the rail is heading, not only where it is */
      function paintArrows(at) {
        var x = at == null ? track.scrollLeft : at;
        if (prev) prev.disabled = x <= 1;
        if (next) next.disabled = x >= maxScroll() - 1;
      }

      function glide(x) {
        try { track.scrollTo({ left: x, behavior: reduce ? 'instant' : 'smooth' }); } catch (e) { track.scrollLeft = x; }
        paintArrows(x);
      }

      function advance(dir) {
        var from = snap(track.scrollLeft);
        var to = clamp(from + dir * step());
        if (Math.abs(to - from) < 1) return false;
        glide(to);
        return true;
      }

      function start() {
        if (reduce || timer) return;
        timer = window.setInterval(function () {
          if (paused || down || document.visibilityState !== 'visible') return;
          if (!advance(1)) stop();
        }, INTERVAL);
      }

      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      function restart() {
        stop();
        start();
      }

      if (prev) prev.addEventListener('click', function () { advance(-1); restart(); });
      if (next) next.addEventListener('click', function () { advance(1); restart(); });

      rail.addEventListener('mouseenter', function () { paused = true; });
      rail.addEventListener('mouseleave', function () { paused = false; });
      rail.addEventListener('focusin', function () { paused = true; });
      rail.addEventListener('focusout', function () { paused = false; });

      /* mouse drag; touch keeps the browser's own scrolling and snap */
      track.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.pointerType !== 'mouse') return;
        down = true; moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = clamp(startScroll - dx);
      });

      function release(e) {
        if (!down) return;
        down = false;
        if (e.pointerId != null) { try { track.releasePointerCapture(e.pointerId); } catch (err) {} }
        if (moved) {
          track.classList.remove('is-dragging');
          glide(snap(track.scrollLeft));
          restart();
          window.setTimeout(function () { moved = false; }, 0);
        }
      }

      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* native scrolling (touch, trackpad): snap to a card once it settles */
      track.addEventListener('scroll', function () {
        paintArrows();
        if (down) return;
        window.clearTimeout(settle);
        settle = window.setTimeout(function () {
          var to = snap(track.scrollLeft);
          if (Math.abs(to - track.scrollLeft) > 1) glide(to);
        }, 160);
      }, { passive: true });

      window.addEventListener('resize', function () { glide(snap(track.scrollLeft)); paintArrows(); });
      paintArrows();

      /* only run while the rail is on screen */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? start() : stop();
        }, { threshold: 0.1 }).observe(rail);
      } else {
        start();
      }
    });
  }

  /* "You may also like": the first paint comes from the product's own
     collection so the rail is never empty; Shopify's recommendations
     endpoint then answers with real related products rendered through the
     same section, and we swap the cards in. Rail listeners live on the
     track element, not the cards, so the swap keeps drag, snap and arrows. */
  function recs() {
    [].slice.call(document.querySelectorAll('[data-sk-recs-url]')).forEach(function (rail) {
      var url = rail.getAttribute('data-sk-recs-url');
      if (!url) return;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-sk-rail-track][data-sk-recs-real]');
          var track = rail.querySelector('[data-sk-rail-track]');
          if (!fresh || !track || !fresh.children.length) return;
          track.innerHTML = fresh.innerHTML;
          rails();
        })
        .catch(function () {});
    });
  }

  function boot() {
    heroVideo();
    headerSolid();
    rails();
    recs();
    strip();
    menus();
    drawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
